import { StarRating } from "@/components/base/ProductCard";

const reviews = [
  { id: 1, author: "James W.", role: "General Contractor", rating: 5, comment: "STRAY LOFT has become my go-to for all tool purchases. The quality is consistently excellent and the prices are fair. The DeWalt drill I bought has been running strong for 8 months on job sites.", product: "DeWalt 20V Drill" },
  { id: 2, author: "Maria S.", role: "DIY Enthusiast", rating: 5, comment: "I was nervous buying tools online but the product descriptions are accurate and shipping was fast. The Craftsman tool set is exactly what I needed for my home renovation project.", product: "Craftsman 230-Piece Set" },
  { id: 3, author: "Robert K.", role: "Master Electrician", rating: 5, comment: "The Fluke multimeter I ordered is genuine and works perfectly. Great selection of professional-grade electrical tools. Will definitely order again.", product: "Fluke 117 Multimeter" },
  { id: 4, author: "Lisa T.", role: "Carpenter", rating: 4, comment: "Fast shipping and well-packaged. The Milwaukee circular saw arrived in perfect condition. It's been a workhorse on my framing projects. Highly recommend this store.", product: "Milwaukee M18 Circular Saw" },
  { id: 5, author: "David M.", role: "Plumber", rating: 5, comment: "Ordered the Ridgid pipe wrench and Channellock pliers set together. Both arrived quickly and are exactly as described. These are the real deal, not knockoffs.", product: "Ridgid Pipe Wrench" },
  { id: 6, author: "Sarah P.", role: "Home Inspector", rating: 5, comment: "The Bosch laser level is incredibly accurate. I use it daily for my inspection work. STRAY LOFT had the best price I found anywhere and it shipped the next day.", product: "Bosch Laser Level" },
];

const ReviewsSection: React.FC = () => (
  <section className="py-20 bg-white">
    <div className="max-w-7xl mx-auto px-4 md:px-6">
      <div className="text-center mb-12">
        <span className="inline-block px-3 py-1 bg-orange-100 text-orange-600 text-xs font-semibold rounded-full uppercase tracking-wide mb-3">
          Customer Reviews
        </span>
        <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">
          What Professionals Say
        </h2>
        <p className="text-gray-500 text-lg">Real reviews from verified customers</p>

        <div className="flex items-center justify-center gap-6 mt-6">
          <div className="text-center">
            <div className="text-4xl font-black text-gray-900">4.8</div>
            <div className="flex justify-center mt-1">
              <StarRating rating={4.8} size="text-sm" />
            </div>
            <div className="text-gray-500 text-sm mt-1">Average Rating</div>
          </div>
          <div className="w-px h-12 bg-gray-200"></div>
          <div className="text-center">
            <div className="text-4xl font-black text-gray-900">3,200+</div>
            <div className="text-gray-500 text-sm mt-1">Total Reviews</div>
          </div>
          <div className="w-px h-12 bg-gray-200"></div>
          <div className="text-center">
            <div className="text-4xl font-black text-gray-900">98%</div>
            <div className="text-gray-500 text-sm mt-1">Recommend Us</div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {reviews.map((review) => (
          <div key={review.id} className="bg-gray-50 rounded-xl p-6 border border-gray-100">
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-orange-500 rounded-full text-white font-bold text-sm flex-shrink-0">
                  {review.author.charAt(0)}
                </div>
                <div>
                  <div className="font-semibold text-gray-900 text-sm">{review.author}</div>
                  <div className="text-gray-500 text-xs">{review.role}</div>
                </div>
              </div>
              <StarRating rating={review.rating} />
            </div>
            <p className="text-gray-600 text-sm leading-relaxed mb-3">&ldquo;{review.comment}&rdquo;</p>
            <div className="flex items-center gap-1 text-xs text-orange-500">
              <i className="ri-shopping-bag-line"></i>
              <span>Purchased: {review.product}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ReviewsSection;
